
import { defineComponent } from "vue";
import firebaseConfig from "@/firebase";
import { getFirestore, setDoc, doc } from "firebase/firestore";
import { debounce } from "debounce";
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  TwitterAuthProvider,
  GithubAuthProvider,
} from "firebase/auth";
const provider = new GoogleAuthProvider();
const providerTwitter = new TwitterAuthProvider();
const providerGithub = new GithubAuthProvider();
firebaseConfig;
const auth = getAuth();
const db: any = getFirestore();
const docref = doc(db, "documents", "users");
export default defineComponent({
  name: "LoginView",
  methods: {
    back() {
      return this.$router.push("/");
    },
    handleSignInGoogle() {
      signInWithPopup(auth, provider)
        .then((result) => {
          this.debounceUpdate(result);
        })
        .catch((error) => {
          this.handleException(error);
        });
    },
    handleSignInTwitter() {
      signInWithPopup(auth, providerTwitter)
        .then((result) => {
          this.debounceUpdate(result);
        })
        .catch((error) => {
          this.handleException(error);
        });
    },
    handleSignInGitHub() {
      signInWithPopup(auth, providerGithub)
        .then((result) => {
          this.debounceUpdate(result);
        })
        .catch((error) => {
          this.handleException(error);
        });
    },
    updateFirestore(docRef: any, value: any) {
      setDoc(docRef, value)
        .then((docRef) => {
          localStorage.setItem("username", value.username as string);
          localStorage.setItem("email", value.email as string);
          localStorage.setItem("img", value.img as string);
          this.$store.commit("setSignedIn", true);
          this.$router.push("/dashboard");
          location.reload();
        })
        .catch((error: any) => {
          this.handleException(error);
        });
    },
    debounceUpdate(value: any) {
      const res = {
        username: value.user.displayName as string,
        email: value.user.email as string,
        img: value.user.photoURL as string,
        isSignedIn: true,
      };
      this.updateFirestore(docref, res);
    },
    handleException(e: any) {
      console.error(e);
      this.$router.push("/auth");
    },
  },
});
